// This composable is used to get service fields for all forms
import type { FieldValueResult } from '@/components/documents/Foxit/FormMapping/composables/FieldValueProvider'
import type { MappedCartItem } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const useOtherFields = () => {
	const {
		findCartItems,
		findCartItemsInMultipleSubcategories,
		getFieldPrice,
		getFieldDescription,
	} = useFormFillHelper()

	const otherOtherLine1Desc = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ?? findCartItems(PbProductType.Other, PbSubcategory.Other)
		return [
			{
				name: fieldName,
				value: getFieldDescription(items),
				format: false,
				section: 'other',
			},
		]
	}

	const otherOtherLine1Price = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ?? findCartItems(PbProductType.Other, PbSubcategory.Other)
		return [
			{
				name: fieldName,
				value: getFieldPrice(items),
				format: true,
				section: 'other',
				supplementalItems: items,
			},
		]
	}

	const otherOtherLine1WithDiscountFields = (
		fieldNames: Record<string, string>
	): FieldValueResult[] => {
		const items = findCartItemsInMultipleSubcategories(PbProductType.Other, [
			PbSubcategory.Other,
			PbSubcategory.Discount,
		])
		return [
			...otherOtherLine1Desc(fieldNames.description, items),
			...otherOtherLine1Price(fieldNames.price, items),
		]
	}

	return {
		otherOtherLine1Desc,
		otherOtherLine1Price,
		otherOtherLine1WithDiscountFields,
	}
}
